import React from 'react';
import { UserModel } from './useUserManagement';
import { effectivePremiumTruth } from './entitlementState';

const UserList: React.FC<{ model: UserModel }> = ({ model }) => {
  const {
    users, sortedUsers, loading, sortBy, setSortBy,
    selectedUser, openUserDetail, isSuspended,
  } = model;

  return (
    <div className="rp-bento-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold" style={{ color: 'var(--rp-text-secondary)' }}>
          {users.length} user{users.length !== 1 ? 's' : ''}
        </h3>
        <select
          value={sortBy}
          onChange={e => setSortBy(e.target.value as typeof sortBy)}
          aria-label="Sort users"
          className="text-[10px] px-2 py-1 rounded-lg cursor-pointer"
          style={{ backgroundColor: 'var(--rp-surface-secondary)', border: '1px solid var(--rp-border)', color: 'var(--rp-text-secondary)' }}
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="name_az">Name A–Z</option>
          <option value="name_za">Name Z–A</option>
          <option value="premium">Premium First</option>
          <option value="suspended">Suspended First</option>
        </select>
      </div>
      <div className="space-y-1 max-h-[600px] overflow-y-auto">
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin w-6 h-6 border-2 rounded-full mx-auto mb-3" style={{ borderColor: 'var(--rp-border)', borderTopColor: 'var(--rp-text-secondary)' }} />
            <p className="text-xs" style={{ color: 'var(--rp-text-tertiary)' }}>Loading...</p>
          </div>
        ) : users.length === 0 ? (
          <p className="text-center py-8 text-sm" style={{ color: 'var(--rp-text-tertiary)' }}>No users found</p>
        ) : (
          sortedUsers.map(user => (
            <div
              key={user.id}
              onClick={() => openUserDetail(user.id)}
              className="p-3 rounded-lg cursor-pointer transition-all"
              style={{
                backgroundColor: selectedUser?.id === user.id ? 'rgba(59,130,246,0.1)' : 'var(--rp-surface-secondary)',
                outline: selectedUser?.id === user.id ? '1px solid rgba(59,130,246,0.5)' : 'none',
              }}
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                  style={{
                    backgroundColor: isSuspended(user.banned_until) ? 'rgba(239,68,68,0.2)' : 'rgba(59,130,246,0.2)',
                    color: isSuspended(user.banned_until) ? 'var(--admin-error)' : 'var(--rp-primary)',
                  }}
                >
                  {(user.display_name || user.email || '?')[0].toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold truncate" style={{ color: 'var(--rp-text)' }}>
                      {user.display_name || user.username || 'No name'}
                    </span>
                    {isSuspended(user.banned_until) && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-500/20 text-red-400 flex-shrink-0">SUSPENDED</span>
                    )}
                    {effectivePremiumTruth(user) === 'premium' && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-yellow-500/20 text-yellow-400 flex-shrink-0">PRO</span>
                    )}
                  </div>
                  <p className="text-xs truncate" style={{ color: 'var(--rp-text-tertiary)' }}>{user.email}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UserList;
